import clsx from 'clsx';
import type { Person } from '@/utils/commsHelpers';

interface Props {
  person: Person | undefined;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const SIZE: Record<NonNullable<Props['size']>, string> = {
  sm: 'h-6 w-6 text-[9px]',
  md: 'h-8 w-8 text-[10px]',
  lg: 'h-10 w-10 text-[11px]',
};

export default function Avatar({ person, size = 'md', className }: Props) {
  if (!person) {
    return (
      <span
        className={clsx(
          'inline-flex items-center justify-center rounded-full bg-ink-soft text-cream-soft font-inter uppercase tracking-widest',
          SIZE[size],
          className,
        )}
      >
        ??
      </span>
    );
  }
  if (person.avatarUrl) {
    return (
      <img
        src={person.avatarUrl}
        alt={person.displayName}
        loading="lazy"
        className={clsx(
          'rounded-full object-cover border border-gold-dim/30',
          SIZE[size],
          className,
        )}
      />
    );
  }
  return (
    <span
      title={person.displayName}
      className={clsx(
        'inline-flex items-center justify-center rounded-full font-inter uppercase tracking-widest border border-gold-dim/40',
        person.id === 'system-bot' || person.id === 'system-ai-voice'
          ? 'bg-gold/20 text-gold-bright'
          : 'bg-ink-soft text-cream-soft',
        SIZE[size],
        className,
      )}
    >
      {person.initials}
    </span>
  );
}
